import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OcorrenciaTipoService } from '../../services/ocorrencia-tipo.service';
import { CarregandoService } from '../../services/carregando.service';
import { NotificacaoService } from '../../services/notificacao.service';
import { UtilitarioService } from '../../services/utilitario.service';
import { Ocorrencia } from '../../models/ocorrencia';
import { OcorrenciaTipo } from '../../models/ocorrencia-tipo';
import { Funcionario } from '../../models/funcionario';
import { OcorrenciaService } from '../../services/ocorrencia.service';
import { MatDialog } from '@angular/material';
import { OcorrenciaTipoModalComponent } from '../../modals/ocorrencia-tipo-modal/ocorrencia-tipo-modal.component';
import { OcorrenciaCabecalho } from '../../models/ocorrencia-cabecalho';
import { FuncionarioService } from '../../services/funcionario.service';
import { PerfilDoUsuario, StatusDaOcorrencia } from '../../models/enum';
import { GlobalService } from '../../services/global.service';
import { OcorrenciaAnexoService } from 'src/app/services/ocorrencia-anexo.service';
import { OcorrenciaAnexo } from 'src/app/models/ocorrencia-anexo';
import { CRMHierarquiaUsuarioService } from 'src/app/services/crmhierarquia-usuario.service';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { Setor } from 'src/app/models/setor';
import { SetorService } from 'src/app/services/setor.service';
import { MASKS } from 'ng-brazil';
import { PremissasService } from 'src/app/services/premissas.service';
import { CRMHierarquiaUsuario } from 'src/app/models/crmhierarquia-usuario';
import { EtapaOcorrencia } from 'src/app/models/etapa-ocorrencia';
import { Transportadora } from 'src/app/models/transportadora';
import { TransportadoraService } from 'src/app/services/transportadora.service';

declare const $: any;
@Component({
  selector: 'app-cadastrar-controle-ocorrencia',
  templateUrl: './cadastrar-controle-ocorrencia.component.html',
  styleUrls: ['./cadastrar-controle-ocorrencia.component.scss']
})
export class CadastrarControleOcorrenciaComponent implements OnInit {
  ocorrenciatipo: OcorrenciaTipo[] = [];
  funcionarios: CRMHierarquiaUsuario[] = [];
  idOcorrencia: number;
  idCupom: string;
  ocorrencia: Ocorrencia = new Ocorrencia();
  cabecalho: OcorrenciaCabecalho = new OcorrenciaCabecalho();
  funcionarioSelecionado: number;
  tipoSelecionado: number;
  veioDoModal: boolean;
  administrador: boolean;

  setores: Setor[] = [];

  public MASKS = MASKS;

  files: File[] = [];
  anexos: OcorrenciaAnexo[] = [];

  superiorOuIgual = true;

  arquivos = [];

  usuarioLogado: UsuarioLogado;

  possuiExtras = false;

  integrador = false;
  integradorPodeAbrirOcorrencia = false;

  etapasOcorrencia: EtapaOcorrencia[] = [];
  etapaOcorrenciaSelecionada;
  naoEditaEtapa: boolean = false;

  transportadoras: Transportadora[] = [];
  transportadoraSelecionada = undefined;

  statusEntrega = [{ id: 0, descricao: 'Em Andamento' }, { id: 1, descricao: 'Entregue' }];
  statusEntregaSelecionado = null;
  mostraStatusEntrega = false;
  minDate: Date = new Date();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ocorrenciaTipoService: OcorrenciaTipoService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private ocorrenciaService: OcorrenciaService,
    private funcionarioService: FuncionarioService,
    private globalService: GlobalService,
    public dialog: MatDialog,
    private ocorrenciaAnexoService: OcorrenciaAnexoService,
    private utilitarioService: UtilitarioService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private setorService: SetorService,
    private premissasService: PremissasService,
    private transportadoraService: TransportadoraService
  ) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.idCupom = this.router.getCurrentNavigation().extras.state.idCupom;
      this.veioDoModal = !!this.router.getCurrentNavigation().extras.state.veioDoModal;
      this.possuiExtras = true;
    }
  }

  async ngOnInit() {
    this.minDate = new Date();
    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.integrador = await this.globalService.integrador();

    if (this.integrador) {
      await this.buscarIntegradorPodeAbrirOcorrencia();

      if (!this.integradorPodeAbrirOcorrencia) {
        this.router.navigateByUrl('/pedidos');
      }
    }

    if (this.veioDoModal) {
      this.funcionarioSelecionado = this.usuarioLogado.id;
    }

    if (this.possuiExtras) {
      this.buscarCabecalho();
    }

    this.ocorrencia.ressalva = true;

    this.administrador = await this.globalService.administrador();

    if (!this.integrador) {
      this.buscarFuncionarios();
    }

    this.naoEditaEtapa = await this.globalService.perfil() === PerfilDoUsuario.Vendedor;

    if (this.route.snapshot.paramMap.get('id')) {
      if (this.integrador) {
        this.router.navigateByUrl('/pedidos');
      } else {
        this.idOcorrencia = Number(this.route.snapshot.paramMap.get('id'));
        this.buscarOcorrencia();
      }
    } else {
      this.buscarSetores();
      this.buscarOcorrenciaTipo();
      this.naoEditaEtapa = true;
    }

    this.buscarTransportadoras();
  }

  buscarTransportadoras() {
    this.carregandoService.mostra('buscarTransportadoras');

    this.transportadoraService.consultarTransportadoras().subscribe(dados => {
      this.transportadoras = dados;

      this.carregandoService.esconde('buscarTransportadoras');
    }, () => {
      this.carregandoService.esconde('buscarTransportadoras');
    });
  }

  async buscarIntegradorPodeAbrirOcorrencia() {

    try {
      this.carregandoService.mostra('buscarIntegradorPodeAbrirOcorrencia');

      this.integradorPodeAbrirOcorrencia = (await this.premissasService.consultarIntegradorPodeAbrirOcorrencia().toPromise()).valor;

    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarIntegradorPodeAbrirOcorrencia');
    }
  }

  salvar() {
    this.ocorrencia.idCupom = this.idCupom;
    this.ocorrencia.idTipoOcorrencia = this.tipoSelecionado;
    this.ocorrencia.idFuncionario = this.funcionarioSelecionado;
    this.ocorrencia.data = new Date();
    this.ocorrencia.dataStatus = new Date();
    this.ocorrencia.status = StatusDaOcorrencia.Novo;
    this.ocorrencia.valor = Number(this.ocorrencia.valor);
    this.ocorrencia.valorBonificacao = this.ocorrencia.valorBonificacao ? Number(this.ocorrencia.valorBonificacao) : 0;

    if (this.transportadoraSelecionada !== null && this.transportadoraSelecionada !== undefined) {
      this.ocorrencia.nomeTransportadora = this.transportadoras.find(t => Number(t.id) === this.transportadoraSelecionada).nome;
      this.ocorrencia.idTransportadora = this.transportadoraSelecionada;
    }

    if (this.ocorrencia.previsaoEntrega != null && this.ocorrencia.previsaoEntrega != undefined) {
      this.ocorrencia.previsaoEntrega = this.ocorrencia.previsaoEntrega;
      this.ocorrencia.statusEntrega = this.statusEntregaSelecionado;
    }

    this.ocorrencia.statusEntrega = this.mostraStatusEntrega ? this.ocorrencia.statusEntrega : null;
    if (!this.ocorrencia.detalhamento) {
      this.ocorrencia.detalhamento = "";
    }

    if (this.ocorrencia.idEtapa != null && this.ocorrencia.idEtapa !== undefined) {
      this.ocorrencia.idEtapa = Number(this.etapaOcorrenciaSelecionada);
      this.ocorrencia.dataEtapa = new Date();
      this.ocorrencia.nomeEtapa = this.etapasOcorrencia.find(p => p.id === this.etapaOcorrenciaSelecionada).descricao;
    }
    this.carregandoService.mostra('salvarOcorrencia');
    this.ocorrenciaService.salvar(this.ocorrencia).subscribe(async (idOcorrencia: number) => {
      this.idOcorrencia = idOcorrencia;

      if (this.files.length > 0) {
        await this.salvarAnexos(this.files);
      }

      this.notificacaoService.sucesso('Ocorrência salva com sucesso!!!');
      this.carregandoService.esconde('salvarOcorrencia');

      if (this.integrador) {
        this.router.navigateByUrl('/pedidos');
      } else {
        this.router.navigateByUrl('/controle-ocorrencia/lancamento',
          {
            state: {
              veioDoModal: true,
              idOcorrencia: this.idOcorrencia
            }
          });
      }
    }, (erro) => {
      this.carregandoService.esconde('salvarOcorrencia');
      this.notificacaoService.erro(erro);
    });
  }

  buscarCabecalho() {
    this.carregandoService.mostra('buscarCabecalho');

    this.ocorrenciaService.consultarCabecalho(this.idCupom).subscribe(cabecalho => {
      this.cabecalho = cabecalho;

      if (this.cabecalho != null && this.cabecalho != undefined && this.cabecalho.transportadora) {

        const transportadora = this.transportadoras.find(t => t.nome.includes(this.cabecalho.transportadora));
        if (transportadora) {
          this.ocorrencia.idTransportadora = Number(transportadora.id);
        }
      }

      this.carregandoService.esconde('buscarCabecalho');
    }, (erro) => {
      this.carregandoService.esconde('buscarCabecalho');
      this.notificacaoService.erro(erro);
    });

  }

  buscarSuperioOuIgual() {
    this.carregandoService.mostra('buscarSuperioOuIgual');

    this.hierarquiaService.superiorOuIgual(this.ocorrencia.idFuncionario).subscribe(valor => {
      this.superiorOuIgual = valor;
      this.carregandoService.esconde('buscarSuperioOuIgual');
    }, (erro) => {
      this.carregandoService.esconde('buscarSuperioOuIgual');
      this.notificacaoService.erro(erro);
    });

  }

  buscarFuncionarios() {

    this.carregandoService.mostra('buscarFuncionarios');
    this.funcionarioService.consultarTodosFuncionarios().subscribe(
      (funcionarios: Funcionario[]) => {
        this.funcionarios = funcionarios.map(p => ({ idFuncion: Number(p.idFuncion), nome: p.nome }));
        this.carregandoService.esconde('buscarFuncionarios');
      },
      (err: Error) => {
        this.carregandoService.esconde('buscarFuncionarios');
        this.notificacaoService.erro(err);
      }
    );

    // if (this.administrador || this.integrador) {
    //   this.carregandoService.mostra('buscarFuncionarios');
    //   this.funcionarioService.consultarTodosFuncionarios().subscribe(
    //     (funcionarios: Funcionario[]) => {
    //       this.funcionarios = funcionarios.map(p => ({ idFuncion: Number(p.idFuncion), nome: p.nome }));
    //       this.carregandoService.esconde('buscarFuncionarios');
    //     },
    //     (err: Error) => {
    //       this.carregandoService.esconde('buscarFuncionarios');
    //       this.notificacaoService.erro(err);
    //     }
    //   );
    // }
    // else {
    //   this.carregandoService.mostra('buscaUsuarios');

    //   this.hierarquiaService.consultarHierarquiaDoUsuarioLista().subscribe(resp => {
    //     this.funcionarios = resp;
    //     this.carregandoService.esconde('buscaUsuarios');
    //   }, (erro) => {
    //     this.carregandoService.esconde('buscaUsuarios');
    //     this.notificacaoService.erro(erro);
    //   });
    // }
  }

  buscarOcorrencia() {
    this.carregandoService.mostra('buscarOcorrencia');

    this.ocorrenciaService.consultarPorId(Number(this.idOcorrencia)).subscribe(ocorrencia => {
      this.ocorrencia = ocorrencia;
      this.idCupom = this.ocorrencia.idCupom;
      this.tipoSelecionado = this.ocorrencia.idTipoOcorrencia;
      this.funcionarioSelecionado = this.ocorrencia.idFuncionario;
      this.etapaOcorrenciaSelecionada = this.ocorrencia.idEtapa;
      this.statusEntregaSelecionado = this.ocorrencia.statusEntrega;
      this.transportadoraSelecionada = this.ocorrencia.idTransportadora;

      this.buscarSuperioOuIgual();

      this.buscarCabecalho();

      this.buscarSetores();
      this.buscarOcorrenciaTipo();
      this.buscarEtapasOcorrencia();
      this.exibeStatusOcorrencia();

      this.carregandoService.esconde('buscarOcorrencia');
    }, (erro) => {
      this.carregandoService.esconde('buscarOcorrencia');
      this.notificacaoService.erro(erro);
    });
  }

  buscarOcorrenciaTipo() {
    if (this.ocorrencia.idSetor === null || this.ocorrencia.idSetor === undefined) {
      this.ocorrenciatipo = [];
      this.tipoSelecionado = null;
      this.etapaOcorrenciaSelecionada = null;
      this.etapasOcorrencia = [];
    } else {
      this.carregandoService.mostra('buscarOcorrenciaTipo');
      this.ocorrenciaTipoService.consultarPorIdSetor(this.ocorrencia.idSetor).subscribe(
        (ocorrenciatipo: OcorrenciaTipo[]) => {
          this.ocorrenciatipo = ocorrenciatipo;

          if (this.tipoSelecionado !== null && this.tipoSelecionado !== undefined &&
            !this.ocorrenciatipo.some(p => p.id === this.tipoSelecionado)) {
            this.tipoSelecionado = null;
            this.etapaOcorrenciaSelecionada = null;
            this.etapasOcorrencia = [];
          }

          this.carregandoService.esconde('buscarOcorrenciaTipo');
        },
        (err: Error) => {
          this.carregandoService.esconde('buscarOcorrenciaTipo');
          this.notificacaoService.erro(err);
        }
      );
    }
  }

  buscarSetores() {
    this.carregandoService.mostra('buscarSetores');

    this.setorService.consultarSetores().subscribe((data: any) => {
      this.setores = data;
      this.carregandoService.esconde('buscarSetores');
    }, (erro) => {
      this.carregandoService.esconde('buscarSetores');
      this.notificacaoService.erro(erro);
    });
  }

  buscarEtapasOcorrencia() {
    this.carregandoService.mostra('buscarEtapasOcorrencia');
    this.ocorrenciaService.consultarEtapas(this.ocorrencia.idSetor, this.tipoSelecionado).subscribe((data: any) => {
      this.etapasOcorrencia = data;
      this.carregandoService.esconde('buscarEtapasOcorrencia');
    }, (erro) => {
      this.carregandoService.esconde('buscarEtapasOcorrencia');
      this.notificacaoService.erro(erro);
    });
    // }
  }

  voltar() {
    if (this.veioDoModal) {
      this.router.navigate(['pedidos']);
    } else {
      this.router.navigate(['controle-ocorrencia']);
    }
  }

  getObjectURL(file) {
    // const url = window.URL;
    return URL.createObjectURL(file);
  }

  salvarAnexos(arquivos: File[]) {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('salvarAnexo');

      const dados = new FormData();

      arquivos.forEach((item, index, arr) => {
        dados.append('arquivo_' + index, item);
      });

      this.ocorrenciaAnexoService.salvar(this.idOcorrencia, dados).subscribe(result => {
        this.carregandoService.esconde('salvarAnexo');

        if (this.integrador) {
          this.router.navigateByUrl('/pedidos');
        } else {
          this.router.navigateByUrl('/controle-ocorrencia/lancamento',
            {
              state: {
                veioDoModal: true,
                idOcorrencia: this.idOcorrencia
              }
            });
        }
        resolve();
      }, (erro) => {
        this.carregandoService.esconde('salvarAnexo');
        this.notificacaoService.erro(erro);
        reject();
      });
    });
  }

  async mostrarPreview(img: File) {
    const imgBase64 = await this.convertFileToBase64(img);
    this.utilitarioService.mostrarImagemBase64(imgBase64, img.name);
  }

  convertFileToBase64(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  onSelect(event) {
    this.files.push(...event.addedFiles);
  }

  convertFilesToURL() {
    this.arquivos = this.files.map(item => this.getObjectURL(item));
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);

    this.convertFilesToURL();
  }

  exibeStatusOcorrencia(flag = false) {
    this.mostraStatusEntrega = flag || (this.ocorrencia.previsaoEntrega != null && this.ocorrencia.previsaoEntrega != undefined);
    this.ocorrencia.statusEntrega = this.mostraStatusEntrega ? 0 : this.ocorrencia.statusEntrega;
  }
}
